import React from 'react';

function Dashboard({ projects = [], onNewProject, onSelectProject }) {
  return (
    <div className="dashboard">
      
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        borderRadius: '12px',
        padding: '48px 40px',
        marginBottom: '32px',
        border: '1px solid #334155',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background grid pattern */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'linear-gradient(rgba(220,38,38,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(220,38,38,0.05) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
          pointerEvents: 'none'
        }} />
        
        <div style={{ position: 'relative' }}>
          <div style={{
            display: 'inline-block',
            background: 'rgba(220,38,38,0.15)',
            border: '1px solid rgba(220,38,38,0.3)',
            borderRadius: '20px',
            padding: '4px 14px',
            fontSize: '12px',
            color: '#f87171',
            fontWeight: '600',
            marginBottom: '16px',
            letterSpacing: '0.5px',
            textTransform: 'uppercase'
          }}>
            AI-Powered Estimating
          </div>
          
          <h1 style={{
            fontSize: '36px',
            fontWeight: '800',
            color: '#f1f5f9',
            lineHeight: '1.2',
            marginBottom: '12px',
            letterSpacing: '-0.5px'
          }}>
            Turn blueprints into<br />
            <span style={{ color: '#dc2626' }}>professional proposals</span>
          </h1>
          
          <p style={{
            fontSize: '16px',
            color: '#94a3b8',
            marginBottom: '28px',
            maxWidth: '500px',
            lineHeight: '1.6'
          }}>
            Upload any construction PDF. AI extracts scope across all trades — HVAC, Electrical, Plumbing, Finishes, and more. Generate professional proposals in minutes.
          </p>
          
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button
              onClick={onNewProject}
              style={{
                background: '#dc2626',
                color: 'white',
                border: 'none',
                padding: '14px 28px',
                borderRadius: '8px',
                fontSize: '15px',
                fontWeight: '700',
                cursor: 'pointer',
                letterSpacing: '0.3px'
              }}
            >
              New Estimate
            </button>
            <div style={{ fontSize: '13px', color: '#64748b' }}>
              0.1% variance on real bids &bull; GCs, MEP subs & specialty contractors nationwide
            </div>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '32px'
      }}>
        {[
          { label: 'Accuracy', value: '0.1%', sub: 'variance on real bids' },
          { label: 'Extraction', value: '90–120', sub: 'items per PDF' },
          { label: 'Time Saved', value: '4 hrs', sub: 'per estimate' },
          { label: 'Divisions', value: '12', sub: 'CSI divisions covered' }
        ].map((stat, i) => (
          <div key={i} style={{
            background: 'white',
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            padding: '20px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '28px', fontWeight: '800', color: '#dc2626', lineHeight: 1 }}>{stat.value}</div>
            <div style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', marginTop: '6px' }}>{stat.label}</div>
            <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '3px' }}>{stat.sub}</div>
          </div>
        ))}
      </div>

      {/* How It Works */}
      <div style={{
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '28px',
        marginBottom: '24px'
      }}>
        <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#0f172a', marginBottom: '20px' }}>
          How It Works
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
          {[
            { step: '01', title: 'Upload Your PDF', desc: 'Works best with: scope submittals, permit sets, spec books, and cost proposals. Architectural blueprints extract scope but not costs.' },
            { step: '02', title: 'AI Extracts Scope', desc: 'Automatically identifies 90–120 line items across all CSI divisions — HVAC, electrical, plumbing, finishes, and more' },
            { step: '03', title: 'Generate Proposal', desc: 'Professional branded proposal with your logo, company info, and pricing — ready to send in minutes' }
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
              <div style={{
                background: '#fef2f2',
                color: '#dc2626',
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: '800',
                flexShrink: 0
              }}>{item.step}</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: '700', color: '#0f172a', marginBottom: '4px' }}>{item.title}</div>
                <div style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.5' }}>{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Start Button */}
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <button
          onClick={onNewProject}
          style={{
            background: '#dc2626',
            color: 'white',
            border: 'none',
            padding: '16px 48px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '700',
            cursor: 'pointer',
            width: '100%',
            maxWidth: '400px'
          }}
        >
          Start New Estimate
        </button>
      </div>

      {/* Recent Projects */}
      {projects.length > 0 && (
        <div style={{
          background: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '12px',
          overflow: 'hidden'
        }}>
          <div style={{ padding: '20px 24px', borderBottom: '1px solid #f1f5f9' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Recent Projects</h3>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                <th style={{ padding: '10px 24px', textAlign: 'left', fontSize: '12px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Project</th>
                <th style={{ padding: '10px 24px', textAlign: 'left', fontSize: '12px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Location</th>
                <th style={{ padding: '10px 24px', textAlign: 'left', fontSize: '12px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Date</th>
                <th style={{ padding: '10px 24px', textAlign: 'right', fontSize: '12px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project, i) => (
                <tr key={project.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '14px 24px', fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>{project.project?.name || 'Unknown'}</td>
                  <td style={{ padding: '14px 24px', fontSize: '14px', color: '#64748b' }}>{project.project?.location || '-'}</td>
                  <td style={{ padding: '14px 24px', fontSize: '14px', color: '#64748b' }}>{new Date(project.createdDate).toLocaleDateString()}</td>
                  <td style={{ padding: '14px 24px', textAlign: 'right' }}>
                    <button
                      onClick={() => onSelectProject(project)}
                      style={{
                        background: 'transparent',
                        border: '1px solid #e2e8f0',
                        color: '#475569',
                        padding: '6px 16px',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer'
                      }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
